import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoRacesWidget" */ './CasinoRacesWidget'),
  modules: ['./CasinoRacesWidget'],
  loading: () => <div style={{ height: '218px' }} />
});

export default LoadableWidget;
